module.exports = __webpack_public_path__ + "static/mybambu-ef0da72809fc251cc53d092ba9587492.png";